import { ajax, getLanguage } from '@/api/ajax';

export interface FileInfoVo {
  fileId: string;
  fileName: string;
  fileSize: number;
  objectKey: string;
}

export interface OpenArticleDetailVo {
  articleUuid: string;
  title: string;
  summary: string;
  textContent: string;
  fileList: FileInfoVo[];
  publishTarget: 'B' | 'C';
  publishTime: number;
  topTime: number | null;
  lang: string;
  requiredRead: 0 | 1;
  whetherRead: 0 | 1 | null;
}

export function getArticleDetail(articleUuid: string) {
  return ajax<OpenArticleDetailVo>({
    url: '/api/tis/web/sip/notice/getArticleDetail',
    method: 'post',
    data: { articleUuid, language: getLanguage() }
  });
}
